if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slideLayouts = JSON.parse(this.dataset.slideLayouts || '[]');
      this.isMobile = window.innerWidth < 750; // Adjust this breakpoint as needed
      this.skipFullSlidesOnMobile = this.dataset.skipFullSlidesOnMobile === 'true';
      this.mountSlider();
      window.addEventListener('shopify:block:select', e => {
        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    mountSlider() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval,
        disableOnInteraction: false
      };
      this.slider = new Swiper(this, {
        effect: 'fade',
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        autoplay:
          this.dataset.autoplay === 'true' ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this),
          beforeTransitionStart: this.handleBeforeTransitionStart.bind(this)
        }
      });
    }

    handleSlideChange(swiper) {
      let headerInner = document.querySelector('.header__inner');
      let heroInners = document.querySelectorAll('.hero__inner');
      if (!headerInner || !heroInners) {
        return;
      }
      document.documentElement.style.setProperty(
        '--transparent-header-menu-text-color',
        heroInners[swiper.activeIndex].dataset.headerMenuTextColor
      );
    }

    handleBeforeTransitionStart(swiper) {
      if (this.isMobile && this.skipFullSlidesOnMobile && this.dataset.autoplay === 'true') {
        let nextIndex = swiper.activeIndex + 1;
        if (nextIndex >= this.slideLayouts.length) {
          nextIndex = 0; // Loop back to the start
        }
        while (this.slideLayouts[nextIndex] === 'hero-banner--full') {
          nextIndex++;
          if (nextIndex >= this.slideLayouts.length) {
            nextIndex = 0; // Loop back to the start
          }
          if (nextIndex === swiper.activeIndex) {
            break; // Prevent infinite loop if all slides are 'Full'
          }
        }
        swiper.slideTo(nextIndex);
      }
    }

    handleResize() {
      this.isMobile = window.innerWidth < 750; // Adjust this breakpoint as needed
    }
  }
  customElements.define('hero-slider', HeroSlider);
}